import React, { useState } from 'react';
import { Container, Form, FormGroup, Col, Button, Input } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../actions/users';
import { getAdminUsers } from '../../actions/admin';
import { FaEquals } from 'react-icons/fa';
const SearchCriteria = props => {
	const [attribute_name, setAttributeName] = useState('');
	const [attribute_value, setAttributeValue] = useState('');
	const dispatch = useDispatch();
	const options = [
		{ value: '', label: 'Select the criteria' },
		{ value: 'preferred_username', label: 'User ID' },
		{ value: 'given_name', label: 'First Name' },
		{ value: 'email', label: 'Email ID' },
		{ value: 'family_name', label: 'Last Name' }
	];
	const optionList = options => {
		return options.map((opt, i) => {
			return (
				<option value={opt.value} key={i}>
					{opt.label}
				</option>
			);
		});
	};

	const handleSubmit = e => {
		e.preventDefault();
		dispatch({ type: 'SET_ERROR', data: { error_obj: undefined } });
		if (props.manageAdmin) {
			dispatch({
				type: 'ADMIN_USERS_LIST',
				data: { usersList: undefined, lastKey: undefined }
			});
			dispatch({ type: 'SET_ADMIN_SEARCH_ATTRIBUTE', data: { searchAttributes: undefined } });
			dispatch(getAdminUsers(attribute_name, attribute_value, props.modifyAdminList));
		} else {
			dispatch({
				type: 'USERS_LIST',
				data: { usersList: undefined, lastKey: undefined }
			});
			dispatch({ type: 'SET_SEARCH_ATTRIBUTE', data: { searchAttributes: undefined } });
			dispatch(getUsers(attribute_name, attribute_value, props.action));
		}
	};

	return (
		<Container
			style={{
				border: '3px solid #ddd',
				padding: '1% 3%'
			}}
		>
			<Form onSubmit={handleSubmit}>
				<FormGroup row style={{ margin: '0 0 0 0' }}>
					<Col sm='4'>
						<Input
							type='select'
							name='attribute_name'
							value={attribute_name}
							onChange={e => {
								setAttributeName(e.target.value);
							}}
						>
							{optionList(options)}
						</Input>
					</Col>
					<Col sm='1'>
						<span
							style={{
								fontSize: '20px',
								marginLeft: '25%'
							}}
						>
							<FaEquals />
						</span>
					</Col>
					<Col sm='4'>
						<Input
							type='text'
							name='attribute_value'
							value={attribute_value}
							onChange={e => setAttributeValue(e.target.value)}
						/>
					</Col>
					<Col sm='2'>
						<Button style={{ float: 'left' }} type='submit' disabled={!attribute_value || !attribute_name}>
							Search
						</Button>
					</Col>
				</FormGroup>
			</Form>
		</Container>
	);
};

export default SearchCriteria;
